// src/components/ErrorBoundary.js
import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info.componentStack);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = "/";
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div
        style={{
          padding: "48px 24px",
          maxWidth: 600,
          margin: "0 auto",
          textAlign: "center",
        }}
      >
        <h2 style={{ color: "#c62828" }}>Something went wrong</h2>
        <p style={{ color: "#555", marginBottom: 24 }}>
          An unexpected error occurred. You can try reloading the app.
        </p>
        {this.state.error && (
          <pre
            style={{
              background: "#f5f5f5",
              border: "1px solid #ddd",
              borderRadius: 4,
              padding: 16,
              fontSize: 13,
              textAlign: "left",
              overflowX: "auto",
              marginBottom: 24,
            }}
          >
            {this.state.error.toString()}
          </pre>
        )}
        <button
          onClick={this.handleReload}
          style={{
            padding: "10px 24px",
            backgroundColor: "#1565c0",
            color: "#fff",
            border: "none",
            borderRadius: 4,
            cursor: "pointer",
            fontSize: 14,
          }}
        >
          Reload App
        </button>
      </div>
    );
  }
}
